const keys = {
  apiURL: 'https://api.leomango.com'
}

export default keys;
